import styled from 'styled-components';

import { colorGrey200, colorGrey400, fontFamilyPrimary } from '@/styleUtils';

export const TimestampWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  gap: 8px;
  color: ${colorGrey400};

  svg {
    color: ${colorGrey200};
    margin: 0;
  }
`;

export const Timestamp = styled.div`
  font: 400 13px/16px ${fontFamilyPrimary};
  letter-spacing: 0.13px;
`;
